'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('./browser-05a2bba8.js');
var ReactDOM = require('react-dom');
var ReactDOM__default = _interopDefault(ReactDOM);
var b14 = require('./typography/b14.js');
require('./invariant-8c441586.js');
require('./react-lifecycles-compat.es-59afd828.js');
var s18 = require('./typography/s18.js');
var s20 = require('./typography/s20.js');
var isEmpty = _interopDefault(require('lodash/isEmpty'));
var lodash = require('lodash');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  display: ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"], ["\n  ", ";\n  display: ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  ", "\n  border-radius: 50%;\n  object-fit: cover;\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  border-radius: 50%;\n  object-fit: cover;\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  text-decoration: none;\n  ", ";\n"], ["\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  text-decoration: none;\n  ", ";\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  word-break: break-word;\n  ", ";\n  &:hover {\n    ", "\n  }\n"], ["\n  word-break: break-word;\n  ", ";\n  &:hover {\n    ", "\n  }\n"]);

var FlexContainer = styled__default.div(_templateObject, function (props) {
  return props.onClick && "cursor: pointer";
}, function (props) {
  return props.$inline ? "inline-flex" : "flex";
}, function (props) {
  return props.$alignItems && "align-items: " + props.$alignItems;
}, function (props) {
  return props.$gap && "gap: " + props.$gap;
}, function (props) {
  return props.$flexDirection && "flex-direction: " + props.$flexDirection;
}, function (props) {
  return props.$justifyContent && "justify-content: " + props.$justifyContent;
}, function (props) {
  return props.$margin && "margin: " + props.$margin;
}, function (props) {
  return props.$width && "width: " + props.$width;
}, function (props) {
  return props.$height && "height: " + props.$height;
}, function (props) {
  return props.$borderRadius && "border-radius: " + props.$borderRadius;
}, function (props) {
  return props.$backgroundColor && "background-color: " + props.$backgroundColor;
}, function (props) {
  return props.$mWidth && "width: " + props.$mWidth;
}, function (props) {
  return props.$mHeight && "height: " + props.$mHeight;
});

var AgentBadgeContainer = styled__default(FlexContainer)(_templateObject2, function (props) {
  return props.onClick && "cursor: pointer";
});

var ImageBadge = styled__default.img(_templateObject3, function (props) {
  return props.width && "width: " + props.width + ";";
}, function (props) {
  return props.height && "height: " + props.height + ";";
}, function (props) {
  return props.mWidth && "width: " + props.mWidth + ";";
}, function (props) {
  return props.mHeight && "height: " + props.mHeight + ";";
});
var LinkItem = styled__default.a(_templateObject4, function (props) {
  return props.onClick && "cursor: pointer";
});

var AgentDisplayName = styled__default(s18.default)(_templateObject5, function (props) {
  return props.lineHeight && "line-height: " + props.lineHeight;
}, function (props) {
  return props.titleHoverColor && "color: " + props.titleHoverColor + ";";
});

var VerifiedBadge = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4zNDk3IDguMDE1NTJMMTUuNDQ3NyA1LjQwMTgxQzE1LjUxIDUuMjU0NjkgMTUuNTExNCA1LjA4ODg5IDE1LjQ1MTcgNC45NDA3QzE1LjM5MjEgNC43OTI1MSAxNS4yNzYxIDQuNjczOTkgMTUuMTI5MyA0LjYxMTExTDEyLjUxNiAzLjUxMjkxTDExLjQxOCAwLjg3NzI0MkMxMS4zNTcyIDAuNzMxMTAxIDExLjI0MTQgMC42MTQ2OTEgMTEuMDk1NiAwLjU1MzA3NUMxMC45NDk4IDAuNDkxNDU5IDEwLjc4NTYgMC40ODk1NTkgMTAuNjM4NCAwLjU0Nzc4TDguMDAzMjIgMS42NDU5OEw1LjM4OTk3IDAuNTQ3NzhDNS4yNDI4NyAwLjQ4NTUwMiA1LjA3NzA5IDAuNDg0MDUzIDQuOTI4OTIgMC41NDM3NDFDNC43ODA3NiAwLjYwMzQyOSA0LjY2MjI4IDAuNzE5NDAyIDQuNTk5NCAwLjg2NjI2NkwzLjUwMTQgMy40Nzk5NkwwLjg3NzE4NCA0LjU3ODE2QzAuODAzOSA0LjYwNzEyIDAuNzM3MTI2IDQuNjUwNCAwLjY4MDc1NyA0LjcwNTQ3QzAuNjI0Mzg5IDQuNzYwNTMgMC41Nzk1MzcgNC44MjYzIDAuNTQ4ODY4IDQuODk4ODlDMC41MTgxOTkgNC45NzE0OSAwLjUwMjMxNCA1LjA0OTQ3IDAuNTAyMTI0IDUuMTI4MjhDMC41MDE5MzQgNS4yMDcwOSAwLjUxNzQ0NCA1LjI4NTE1IDAuNTQ3NzYzIDUuMzU3ODlMMS42NDU3NyA3Ljk5MzU2TDAuNTQ3NzYzIDEwLjYwNzNDMC40ODU0OTYgMTAuNzU0NCAwLjQ4NDA2NCAxMC45MjAyIDAuNTQzNzQxIDExLjA2ODRDMC42MDM0MTkgMTEuMjE2NiAwLjcxOTM1NSAxMS4zMzUxIDAuODY2MTkzIDExLjM5OEwzLjQ3OTQ1IDEyLjQ5NjJMNC41Nzc0NSAxNS4xMjA5QzQuNjA2MzIgMTUuMTk1NSA0LjY0OTk4IDE1LjI2MzUgNC43MDU4MiAxNS4zMjA5QzQuNzYxNjcgMTUuMzc4MiA0LjgyODU1IDE1LjQyMzYgNC45MDI0MiAxNS40NTQ0QzQuOTc2MjggMTUuNDg1MiA1LjA1NTYyIDE1LjUwMDcgNS4xMzU2NCAxNS41QzUuMjE1NjUgMTUuNDk5MyA1LjI5NDcgMTUuNDgyNCA1LjM2ODAyIDE1LjQ1MDNMNy45OTIyMyAxNC4zNTIxTDEwLjYwNTUgMTUuNDUwM0MxMC43NTI5IDE1LjUwOTcgMTAuOTE3NSAxNS41MDk3IDExLjA2NDkgMTUuNDUwM0MxMS4yMTIzIDE1LjM5MDkgMTEuMzMwOSAxNS4yNzY4IDExLjM5NjEgMTUuMTMxOEwxMi40OTQxIDEyLjUwNzFMMTUuMTE4MyAxMS40MDlDMTUuMjY3MiAxMS4zNDc5IDE1LjM4NjIgMTEuMjMwOSAxNS40NDk5IDExLjA4MzFDMTUuNTEzNSAxMC45MzUzIDE1LjUxNjcgMTAuNzY4NCAxNS40NTg3IDEwLjYxODJMMTQuMzQ5NyA4LjAxNTUyWiIgZmlsbD0iIzgwQzY0MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjk3NTYgNC43NjE3MkwxMi4yNzEyIDYuMDU3NThMNi43ODExNyAxMS40OTM3TDMuNjczODMgOC4zODU3Nkg2LjI2NTFMNi43ODExNyA4LjkwMTkxTDEwLjk3NTYgNC43NjE3MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = React.useRef(value);
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  var ref = useCommittedRef(fn);
  return React.useCallback(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return React.useState(null);
}

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = React.useRef(true);
  var isMounted = React.useRef(function () {
    return mounted.current;
  });
  React.useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

function useSafeState(state) {
  var isMounted = useMounted();
  return [state[0], React.useCallback(function (nextState) {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect$1(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$1,
  data: {}
};

var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

// This is b/c the Popper lib is all esm files, and would break in a common js only environment

var createPopper = popperGenerator({
  defaultModifiers: [hide$1, popperOffsets$1, computeStyles$1, eventListeners, offset$1, flip$1, preventOverflow$1, arrow$1]
});

var initialPopperStyles = function initialPopperStyles(position) {
  return {
    position: position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
};

var disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false
}; // until docjs supports type exports...

var ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: function effect(_ref) {
    var state = _ref.state;
    return function () {
      var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper;

      if ('removeAttribute' in reference) {
        var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function (id) {
          return id.trim() !== popper.id;
        });
        if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
      }
    };
  },
  fn: function fn(_ref2) {
    var _popper$getAttribute;

    var state = _ref2.state;
    var _state$elements2 = state.elements,
        popper = _state$elements2.popper,
        reference = _state$elements2.reference;
    var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();

    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      var ids = reference.getAttribute('aria-describedby');

      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }

      reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
    }
  }
};
var EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */

function usePopper(referenceElement, popperElement, _temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$enabled = _ref3.enabled,
      enabled = _ref3$enabled === void 0 ? true : _ref3$enabled,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
      _ref3$strategy = _ref3.strategy,
      strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy,
      _ref3$modifiers = _ref3.modifiers,
      modifiers = _ref3$modifiers === void 0 ? EMPTY_MODIFIERS : _ref3$modifiers,
      config = _objectWithoutPropertiesLoose(_ref3, ["enabled", "placement", "strategy", "modifiers"]);

  var popperInstanceRef = React.useRef();
  var update = React.useCallback(function () {
    var _popperInstanceRef$cu;

    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  var forceUpdate = React.useCallback(function () {
    var _popperInstanceRef$cu2;

    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);

  var _useSafeState = useSafeState(React.useState({
    placement: placement,
    update: update,
    forceUpdate: forceUpdate,
    attributes: {},
    styles: {
      popper: initialPopperStyles(strategy),
      arrow: {}
    }
  })),
      popperState = _useSafeState[0],
      setState = _useSafeState[1];

  var updateModifier = React.useMemo(function () {
    return {
      name: 'updateStateModifier',
      enabled: true,
      phase: 'write',
      requires: ['computeStyles'],
      fn: function fn(_ref4) {
        var state = _ref4.state;
        var styles = {};
        var attributes = {};
        Object.keys(state.elements).forEach(function (element) {
          styles[element] = state.styles[element];
          attributes[element] = state.attributes[element];
        });
        setState({
          state: state,
          styles: styles,
          attributes: attributes,
          update: update,
          forceUpdate: forceUpdate,
          placement: state.placement
        });
      }
    };
  }, [update, forceUpdate, setState]);
  React.useEffect(function () {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [updateModifier, disabledApplyStylesModifier])
    }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategy, placement, updateModifier, enabled]);
  React.useEffect(function () {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }

    popperInstanceRef.current = createPopper(referenceElement, popperElement, _extends({}, config, {
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [ariaDescribedByModifier, updateModifier])
    }));
    return function () {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(function (s) {
          return _extends({}, s, {
            attributes: {},
            styles: {
              popper: initialPopperStyles(strategy)
            }
          });
        });
      }
    }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}

/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains$1(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

var warning = function() {};

{
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return ReactDOM__default.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

var ownerDocument$1 = (function (componentOrElement) {
  return ownerDocument(safeFindDOMNode(componentOrElement));
});

var escapeKeyCode = 27;

var noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = React.useRef(false);
  var onClose = onRootClose || noop;
  var handleMouseCapture = React.useCallback(function (e) {
    var currentTarget = getRefTarget(ref);
    warning_1(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains$1(currentTarget, e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  React.useEffect(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = ownerDocument$1(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = listen(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return listen(el, 'mousemove', noop);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

function toModifierMap(modifiers) {
  var result = {};

  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  } // eslint-disable-next-line no-unused-expressions


  modifiers == null ? void 0 : modifiers.forEach(function (m) {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map) {
  if (map === void 0) {
    map = {};
  }

  if (Array.isArray(map)) return map;
  return Object.keys(map).map(function (k) {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig(_ref) {
  var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;

  var enabled = _ref.enabled,
      enableEvents = _ref.enableEvents,
      placement = _ref.placement,
      flip = _ref.flip,
      offset = _ref.offset,
      fixed = _ref.fixed,
      containerPadding = _ref.containerPadding,
      arrowElement = _ref.arrowElement,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
  var modifiers = toModifierMap(popperConfig.modifiers);
  return _extends({}, popperConfig, {
    placement: placement,
    enabled: enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(_extends({}, modifiers, {
      eventListeners: {
        enabled: enableEvents
      },
      preventOverflow: _extends({}, modifiers.preventOverflow, {
        options: containerPadding ? _extends({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: _extends({
          offset: offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: _extends({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: _extends({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: _extends({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

var resolveContainerRef = function resolveContainerRef(ref) {
  var _ref;

  if (typeof document === 'undefined') return null;
  if (ref == null) return ownerDocument().body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  var _useState = React.useState(function () {
    return resolveContainerRef(ref);
  }),
      resolvedRef = _useState[0],
      setRef = _useState[1];

  if (!resolvedRef) {
    var earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  React.useEffect(function () {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  React.useEffect(function () {
    var nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return React.useMemo(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
var Overlay = /*#__PURE__*/React__default.forwardRef(function (props, outerRef) {
  var flip = props.flip,
      offset = props.offset,
      placement = props.placement,
      _props$containerPaddi = props.containerPadding,
      containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi,
      _props$popperConfig = props.popperConfig,
      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
      Transition = props.transition;

  var _useCallbackRef = useCallbackRef(),
      rootElement = _useCallbackRef[0],
      attachRef = _useCallbackRef[1];

  var _useCallbackRef2 = useCallbackRef(),
      arrowElement = _useCallbackRef2[0],
      attachArrowRef = _useCallbackRef2[1];

  var mergedRef = useMergedRefs(attachRef, outerRef);
  var container = useWaitForDOMRef(props.container);
  var target = useWaitForDOMRef(props.target);

  var _useState = React.useState(!props.show),
      exited = _useState[0],
      setExited = _useState[1];

  var _usePopper = usePopper(target, rootElement, mergeOptionsWithPopperConfig({
    placement: placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip: flip,
    offset: offset,
    arrowElement: arrowElement,
    popperConfig: popperConfig
  })),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popper = _objectWithoutPropertiesLoose(_usePopper, ["styles", "attributes"]);

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  var handleHidden = function handleHidden() {
    setExited(true);

    if (props.onExited) {
      props.onExited.apply(props, arguments);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  var mountOverlay = props.show || Transition && !exited;
  useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var child = props.children(_extends({}, popper, {
    show: !!props.show,
    props: _extends({}, attributes.popper, {
      style: styles.popper,
      ref: mergedRef
    }),
    arrowProps: _extends({}, attributes.arrow, {
      style: styles.arrow,
      ref: attachArrowRef
    })
  }));

  if (Transition) {
    var onExit = props.onExit,
        onExiting = props.onExiting,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered;
    child = /*#__PURE__*/React__default.createElement(Transition, {
      "in": props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, child);
  }

  return container ? /*#__PURE__*/ReactDOM__default.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: PropTypes$1.bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: PropTypes$1.oneOf(placements),

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: PropTypes$1.any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: PropTypes$1.any,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: PropTypes$1.bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */
  children: PropTypes$1.func.isRequired,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: PropTypes$1.number,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: PropTypes$1.object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: PropTypes$1.bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: PropTypes$1.oneOf(['click', 'mousedown']),

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: PropTypes$1.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (props.rootClose) {
      var _PropTypes$func;

      return (_PropTypes$func = PropTypes$1.func).isRequired.apply(_PropTypes$func, [props].concat(args));
    }

    return PropTypes$1.func.apply(PropTypes$1, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  // @ts-ignore
  transition: PropTypes$1.elementType,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: PropTypes$1.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: PropTypes$1.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: PropTypes$1.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: PropTypes$1.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: PropTypes$1.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: PropTypes$1.func
};

var _templateObject$1 = _babelHelpers.taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 10;\n"], ["\n  position: absolute;\n  z-index: 10;\n"]),
    _templateObject2$1 = _babelHelpers.taggedTemplateLiteral(["\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  z-index: 10;\n  &::before {\n    content: \"\";\n    border-left-color: transparent;\n    border-top-color: transparent;\n    position: absolute;\n    transform: rotate(45deg);\n    background-color: ", ";\n    width: 10px;\n    height: 10px;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n"], ["\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  z-index: 10;\n  &::before {\n    content: \"\";\n    border-left-color: transparent;\n    border-top-color: transparent;\n    position: absolute;\n    transform: rotate(45deg);\n    background-color: ", ";\n    width: 10px;\n    height: 10px;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n"]),
    _templateObject3$1 = _babelHelpers.taggedTemplateLiteral(["\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: ", ";\n  text-align: center;\n  border-radius: 5px;\n"], ["\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: ", ";\n  text-align: center;\n  border-radius: 5px;\n"]),
    _templateObject4$1 = _babelHelpers.taggedTemplateLiteral(["\n  display: inherit;\n  color: inherit;\n"], ["\n  display: inherit;\n  color: inherit;\n"]);

var Tooltip = styled__default.div(_templateObject$1);

var Arrow = styled__default.div(_templateObject2$1, function (props) {
  return props.background ? props.background : "white";
}, function (p) {
  return {
    left: "right: -5px;",
    right: "left: -5px;",
    top: "bottom: -5px;",
    bottom: "top: -5px;"
  }[p.placement];
});

var Body = styled__default.div(_templateObject3$1, function (props) {
  return props.padding ? props.padding : ": 10px 19px 0px 19px;";
}, function (props) {
  return props.background ? props.background : "white";
}, function (props) {
  return props.color ? props.color : "black";
}, function (props) {
  return props.width ? props.width : "100%;";
});

var WrapperContainer = styled__default.div(_templateObject4$1);

var SimpleTooltip = function SimpleTooltip(props) {
  var bubbleWidth = props.bubbleWidth,
      color = props.color,
      children = props.children,
      position = props.position,
      componentTitle = props.componentTitle,
      background = props.background;

  var _useState = React.useState(false),
      _useState2 = _babelHelpers.slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var triggerRef = React.useRef(null);
  var containerRef = React.useRef(null);

  var handleClick = function handleClick() {
    setShow(true);
  };

  var handleHide = function handleHide() {
    setShow(false);
  };

  return React__default.createElement(
    "div",
    { ref: containerRef },
    React__default.createElement(
      WrapperContainer,
      {
        id: "overlay-toggle",
        ref: triggerRef,
        onClick: handleClick,
        onMouseLeave: handleHide,
        onMouseEnter: handleClick },
      componentTitle
    ),
    React__default.createElement(
      Overlay,
      {
        show: show,
        rootClose: true,
        placement: lodash.lowerCase(position),
        offset: [1, 10],
        container: containerRef,
        onHide: handleHide,
        target: triggerRef },
      function (_ref) {
        var propsOverlay = _ref.props,
            arrowProps = _ref.arrowProps,
            placement = _ref.placement;
        return React__default.createElement(
          Tooltip,
          _babelHelpers._extends({ id: "simple-tooltip" }, propsOverlay, { placement: placement }),
          React__default.createElement(Arrow, _babelHelpers._extends({}, arrowProps, {
            placement: placement,
            background: background,
            style: arrowProps.style
          })),
          React__default.createElement(
            Body,
            {
              background: background,
              padding: "5px 10px",
              width: bubbleWidth,
              color: color },
            children
          )
        );
      }
    )
  );
};

SimpleTooltip.defaultProps = {
  position: "TOP",
  title: "ToolTip",
  background: "black",
  color: "#3b99fc",
  bubbleWidth: "350px",
  componentTitle: {}
};
SimpleTooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SimpleTooltip",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"TOP\"",
        "computed": false
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "\"ToolTip\"",
        "computed": false
      },
      "required": false
    },
    "background": {
      "defaultValue": {
        "value": "\"black\"",
        "computed": false
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "\"#3b99fc\"",
        "computed": false
      },
      "required": false
    },
    "bubbleWidth": {
      "defaultValue": {
        "value": "\"350px\"",
        "computed": false
      },
      "required": false
    },
    "componentTitle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    }
  }
};

/* eslint-disable react/no-array-index-key */

var WrapLinkItem = function WrapLinkItem(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children;
  return onClick ? React__default.createElement(
    LinkItem,
    { onClick: onClick },
    children
  ) : React__default.createElement(
    React__default.Fragment,
    null,
    " ",
    children,
    " "
  );
};

var AgentBadgeInfo = function AgentBadgeInfo(_ref2) {
  var id = _ref2.id,
      displayName = _ref2.displayName,
      information = _ref2.information,
      isVerified = _ref2.isVerified,
      titleSize = _ref2.titleSize,
      subTitleSize = _ref2.subTitleSize,
      subInformations = _ref2.subInformations,
      onClick = _ref2.onClick,
      titleLineHeight = _ref2.titleLineHeight,
      subTitleLineHeight = _ref2.subTitleLineHeight,
      titleWeight = _ref2.titleWeight,
      subTitleWeight = _ref2.subTitleWeight,
      titleColor = _ref2.titleColor,
      titleHoverColor = _ref2.titleHoverColor;

  var arrayOfInformation = typeof information === "string" ? [information] : information;
  return React__default.createElement(
    FlexContainer,
    { id: id + "Info", $flexDirection: "column", $gap: "5px" },
    React__default.createElement(
      FlexContainer,
      { id: id + "DisplayName", $alignItems: "center", $gap: "7.5px" },
      React__default.createElement(
        WrapLinkItem,
        { onClick: onClick },
        React__default.createElement(
          AgentDisplayName,
          {
            margin: "0",
            size: titleSize,
            lineHeight: titleLineHeight,
            weight: titleWeight,
            color: titleColor,
            titleHoverColor: titleHoverColor },
          displayName
        )
      ),
      isVerified && React__default.createElement(
        SimpleTooltip,
        {
          bubbleWidth: "unset",
          position: "TOP",
          background: "black",
          color: "white",
          componentTitle: React__default.createElement(
            FlexContainer,
            { id: id + "DisplayName", $alignItems: "center" },
            React__default.createElement("img", { src: VerifiedBadge, alt: "verified-badge" })
          ) },
        React__default.createElement(
          b14.default,
          { size: "12px", color: "white", margin: "0" },
          "Account verified"
        )
      )
    ),
    React__default.createElement(
      WrapLinkItem,
      { onClick: onClick },
      !isEmpty(arrayOfInformation) && arrayOfInformation.map(function (info, index) {
        return React__default.createElement(
          b14.default,
          {
            key: id + "Information_" + index,
            id: id + "Information_" + index,
            margin: index === arrayOfInformation.length - 1 && subInformations.length > 0 ? "0 0 5px 0" : "0",
            size: subTitleSize,
            weight: isEmpty(subInformations) ? "400" : subTitleWeight,
            lineHeight: subTitleLineHeight },
          info
        );
      }),
      !isEmpty(subInformations) && subInformations.map(function (subInformation, subInformationId) {
        return React__default.createElement(
          b14.default,
          {
            id: id + "subInformation-" + subInformationId,
            margin: "0",
            size: subTitleSize,
            weight: "400",
            lineHeight: subTitleLineHeight },
          subInformation
        );
      })
    )
  );
};

AgentBadgeInfo.propTypes = {
  id: PropTypes$1.string,
  displayName: PropTypes$1.string.isRequired,
  information: PropTypes$1.arrayOf(PropTypes$1.string),
  isVerified: PropTypes$1.bool,
  titleSize: PropTypes$1.string,
  subTitleSize: PropTypes$1.string,
  subInformations: PropTypes$1.array,
  titleLineHeight: PropTypes$1.string,
  subTitleLineHeight: PropTypes$1.string,
  titleWeight: PropTypes$1.string,
  subTitleWeight: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  titleHoverColor: PropTypes$1.string
};

AgentBadgeInfo.defaultProps = {
  id: "",
  titleSize: "18px",
  subTitleSize: "12px",
  subInformations: [],
  information: [],
  subTitleWeight: "600"
};
AgentBadgeInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AgentBadgeInfo",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleSize": {
      "defaultValue": {
        "value": "\"18px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleSize": {
      "defaultValue": {
        "value": "\"12px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subInformations": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "information": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": ""
    },
    "subTitleWeight": {
      "defaultValue": {
        "value": "\"600\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "displayName": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "isVerified": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "titleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleHoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var TextImageBadge = function TextImageBadge(_ref) {
  var id = _ref.id,
      src = _ref.src,
      initialFirstName = _ref.initialFirstName,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      width = _ref.width,
      height = _ref.height,
      mWidth = _ref.mWidth,
      mHeight = _ref.mHeight,
      onClick = _ref.onClick;
  return React__default.createElement(
    FlexContainer,
    {
      id: id + "ImageBadge",
      $alignItems: "center",
      $justifyContent: "center",
      $width: width,
      $height: height,
      $mWidth: mWidth,
      $mHeight: mHeight,
      $borderRadius: "50%",
      $backgroundColor: !src && backgroundColor,
      onClick: onClick },
    src ? React__default.createElement(ImageBadge, {
      width: width,
      height: height,
      src: src,
      mHeight: mHeight,
      mWidth: mWidth
    }) : React__default.createElement(
      s20.default,
      { margin: "0", color: textColor, mSize: "20px" },
      initialFirstName
    )
  );
};

TextImageBadge.propTypes = {
  id: PropTypes$1.string,
  src: PropTypes$1.string,
  initialFirstName: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  textColor: PropTypes$1.string,
  width: PropTypes$1.string,
  height: PropTypes$1.string,
  mWidth: PropTypes$1.string,
  mHeight: PropTypes$1.string
};

TextImageBadge.defaultProps = {
  id: "",
  backgroundColor: settings.COLOR.deepBlueDark,
  textColor: settings.COLOR.white,
  width: "40px",
  height: "40px",
  mWidth: "40px",
  mHeight: "40px"
};
TextImageBadge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextImageBadge",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "backgroundColor": {
      "defaultValue": {
        "value": "COLOR.deepBlueDark",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "textColor": {
      "defaultValue": {
        "value": "COLOR.white",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "\"40px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "defaultValue": {
        "value": "\"40px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mWidth": {
      "defaultValue": {
        "value": "\"40px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mHeight": {
      "defaultValue": {
        "value": "\"40px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "src": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "initialFirstName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var DefaultAvatar = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM0MDUzNjkiLz4KPG1hc2sgaWQ9Im1hc2swXzIzMDJfNjUyNDIiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+CjxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIiBmaWxsPSIjQzRDNEM0Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yMzAyXzY1MjQyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjMuOTc3MyAyNS40NjA3QzIyLjcwODcgMjYuMzcxMiAyMS4yMTcyIDI2Ljg1NzEgMTkuNjkxNSAyNi44NTcxQzE3LjY0NTUgMjYuODU3MSAxNS42ODM0IDI1Ljk4NDIgMTQuMjM2NiAyNC40MzAzQzEyLjc4OTkgMjIuODc2NCAxMS45NzcyIDIwLjc2ODkgMTEuOTc3MiAxOC41NzE0QzExLjk3NzIgMTYuOTMyNyAxMi40Mjk2IDE1LjMzMDcgMTMuMjc3MyAxMy45NjgxQzE0LjEyNDkgMTIuNjA1NiAxNS4zMjk3IDExLjU0MzYgMTYuNzM5MyAxMC45MTY0QzE4LjE0ODkgMTAuMjg5MyAxOS43IDEwLjEyNTIgMjEuMTk2NSAxMC40NDQ5QzIyLjY5MjkgMTAuNzY0NiAyNC4wNjc0IDExLjU1MzggMjUuMTQ2MyAxMi43MTI1QzI2LjIyNTIgMTMuODcxMyAyNi45NTk5IDE1LjM0NzcgMjcuMjU3NSAxNi45NTVDMjcuNTU1MiAxOC41NjIyIDI3LjQwMjQgMjAuMjI4MiAyNi44MTg1IDIxLjc0MjJDMjYuMjM0NyAyMy4yNTYzIDI1LjI0NTkgMjQuNTUwMyAyMy45NzczIDI1LjQ2MDdaTTE4LjcxNDQgMjguMzYzNkgyMS4yODU4QzI1LjAzNjcgMjguMzYzNiAyOC42MzQgMjkuODE4NiAzMS4yODYzIDMyLjQwODRDMzMuOTM4NiAzNC45OTgxIDM1LjQyODcgMzguNTEwNiAzNS40Mjg3IDQyLjE3MzJDMzUuNDI4NyA0Mi41MDYxIDM1LjI5MzIgNDIuODI1NCAzNS4wNTIxIDQzLjA2MDlDMzQuODExIDQzLjI5NjMgMzQuNDg0IDQzLjQyODYgMzQuMTQzIDQzLjQyODZINS44NTcyNUM1LjUxNjI1IDQzLjQyODYgNS4xODkyMyA0My4yOTYzIDQuOTQ4MTEgNDMuMDYwOUM0LjcwNjk5IDQyLjgyNTQgNC41NzE1MyA0Mi41MDYxIDQuNTcxNTMgNDIuMTczMkM0LjU3MTUzIDM4LjUxMDYgNi4wNjE1OCAzNC45OTgxIDguNzEzODggMzIuNDA4NEMxMS4zNjYyIDI5LjgxODYgMTQuOTYzNSAyOC4zNjM2IDE4LjcxNDQgMjguMzYzNloiIGZpbGw9IiNFMkYwRkYiLz4KPC9nPgo8L3N2Zz4K";

var AgentBadgeSecondary = function AgentBadgeSecondary(_ref) {
  var id = _ref.id,
      imageSrc = _ref.imageSrc,
      displayName = _ref.displayName,
      information = _ref.information,
      isVerified = _ref.isVerified,
      onClick = _ref.onClick,
      badgeStyle = _ref.badgeStyle,
      margin = _ref.margin,
      width = _ref.width,
      height = _ref.height,
      titleSize = _ref.titleSize,
      subTitleSize = _ref.subTitleSize,
      mHeight = _ref.mHeight,
      mWidth = _ref.mWidth,
      initialFirstName = _ref.initialFirstName,
      subInformations = _ref.subInformations,
      titleLineHeight = _ref.titleLineHeight,
      subTitleLineHeight = _ref.subTitleLineHeight,
      titleWeight = _ref.titleWeight,
      subTitleWeight = _ref.subTitleWeight,
      titleColor = _ref.titleColor,
      titleHoverColor = _ref.titleHoverColor;
  return React__default.createElement(
    AgentBadgeContainer,
    {
      id: id,
      $inline: true,
      $alignItems: "start",
      $gap: "10px",
      $margin: margin },
    React__default.createElement(TextImageBadge, _babelHelpers._extends({
      id: id,
      src: imageSrc || DefaultAvatar,
      initialFirstName: initialFirstName,
      width: width,
      height: height
    }, badgeStyle, {
      mWidth: mWidth,
      mHeight: mHeight,
      onClick: onClick
    })),
    React__default.createElement(AgentBadgeInfo, {
      id: id,
      displayName: displayName,
      information: information,
      isVerified: isVerified,
      titleSize: titleSize,
      subTitleSize: subTitleSize,
      subInformations: subInformations,
      onClick: onClick,
      titleLineHeight: titleLineHeight,
      subTitleLineHeight: subTitleLineHeight,
      titleWeight: titleWeight,
      subTitleWeight: subTitleWeight,
      titleColor: titleColor,
      titleHoverColor: titleHoverColor
    })
  );
};

AgentBadgeSecondary.propTypes = {
  id: PropTypes$1.string,
  displayName: PropTypes$1.string.isRequired,
  information: PropTypes$1.string,
  isVerified: PropTypes$1.bool,
  titleSize: PropTypes$1.string,
  subTitleSize: PropTypes$1.string,
  subInformations: PropTypes$1.array,
  titleLineHeight: PropTypes$1.string,
  subTitleLineHeight: PropTypes$1.string,
  titleWeight: PropTypes$1.string,
  subTitleWeight: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  titleHoverColor: PropTypes$1.string
};

AgentBadgeSecondary.defaultProps = {
  id: "",
  titleSize: "18px",
  subTitleSize: "12px",
  subInformations: []
};
AgentBadgeSecondary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AgentBadgeSecondary",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleSize": {
      "defaultValue": {
        "value": "\"18px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleSize": {
      "defaultValue": {
        "value": "\"12px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subInformations": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "displayName": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "information": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isVerified": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "titleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleHoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var AgentBadgePrimary = function AgentBadgePrimary(_ref) {
  var id = _ref.id,
      imageSrc = _ref.imageSrc,
      displayName = _ref.displayName,
      information = _ref.information,
      isVerified = _ref.isVerified,
      onClick = _ref.onClick,
      badgeStyle = _ref.badgeStyle,
      margin = _ref.margin,
      width = _ref.width,
      height = _ref.height,
      titleSize = _ref.titleSize,
      subTitleSize = _ref.subTitleSize,
      mHeight = _ref.mHeight,
      mWidth = _ref.mWidth,
      initialFirstName = _ref.initialFirstName,
      titleLineHeight = _ref.titleLineHeight,
      subTitleLineHeight = _ref.subTitleLineHeight,
      titleWeight = _ref.titleWeight,
      titleColor = _ref.titleColor,
      titleHoverColor = _ref.titleHoverColor;
  return React__default.createElement(
    AgentBadgeContainer,
    {
      id: id,
      $inline: true,
      $alignItems: "center",
      $gap: "10px",
      $margin: margin },
    React__default.createElement(TextImageBadge, _babelHelpers._extends({
      id: id,
      src: imageSrc,
      initialFirstName: initialFirstName,
      width: width,
      height: height
    }, badgeStyle, {
      mWidth: mWidth,
      mHeight: mHeight,
      onClick: onClick
    })),
    React__default.createElement(AgentBadgeInfo, {
      id: id,
      displayName: displayName,
      information: information,
      isVerified: isVerified,
      titleSize: titleSize,
      subTitleSize: subTitleSize,
      onClick: onClick,
      titleLineHeight: titleLineHeight,
      subTitleLineHeight: subTitleLineHeight,
      titleWeight: titleWeight,
      titleColor: titleColor,
      titleHoverColor: titleHoverColor
    })
  );
};

AgentBadgePrimary.propTypes = {
  /** Component ID */
  id: PropTypes$1.string,
  /** Image source */
  imageSrc: PropTypes$1.string,
  /** Agent display name */
  displayName: PropTypes$1.string.isRequired,
  /** Agent information */
  information: PropTypes$1.string,
  /** Is agent verified */
  isVerified: PropTypes$1.bool,
  /** Component's margin */
  margin: PropTypes$1.string,
  /** On click badge function */
  onClick: PropTypes$1.func,
  /* width of imageSrc */
  width: PropTypes$1.string,
  /* height of imageSrc */
  height: PropTypes$1.string,
  /* width of imageSrc */
  mWidth: PropTypes$1.string,
  /* height of imageSrc */
  mHeight: PropTypes$1.string,
  /* font size of title */
  titleSize: PropTypes$1.string,
  /* font size of sub title */
  subTitleSize: PropTypes$1.string,
  /** Badge styles */
  badgeStyle: PropTypes$1.shape({
    /** Badge background color */
    backgroundColor: PropTypes$1.string,
    /** Badge text color */
    textColor: PropTypes$1.string
  }),
  /** lineHeight of title */
  titleLineHeight: PropTypes$1.string,
  /** lineHeight of sub title */
  subTitleLineHeight: PropTypes$1.string,
  /** weight of title  */
  titleWeight: PropTypes$1.string,
  /** color of title */
  titleColor: PropTypes$1.string,
  /** color of hover title */
  titleHoverColor: PropTypes$1.string
};

AgentBadgePrimary.defaultProps = {
  id: "agentBadge"
};
AgentBadgePrimary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AgentBadgePrimary",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"agentBadge\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Component ID"
    },
    "imageSrc": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Image source"
    },
    "displayName": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Agent display name"
    },
    "information": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Agent information"
    },
    "isVerified": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Is agent verified"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Component's margin"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "On click badge function"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "badgeStyle": {
      "type": {
        "name": "shape",
        "value": {
          "backgroundColor": {
            "name": "string",
            "description": "Badge background color",
            "required": false
          },
          "textColor": {
            "name": "string",
            "description": "Badge text color",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Badge styles"
    },
    "titleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "lineHeight of title"
    },
    "subTitleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "lineHeight of sub title"
    },
    "titleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "weight of title"
    },
    "titleColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of title"
    },
    "titleHoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of hover title"
    }
  }
};

var AgentBadge = function AgentBadge(_ref) {
  var type = _ref.type,
      props = _babelHelpers.objectWithoutProperties(_ref, ["type"]);
  var displayName = props.displayName;

  var initialFirstName = displayName.charAt(0).toUpperCase();
  switch (type) {
    case "secondary":
      return React__default.createElement(AgentBadgeSecondary, props);
    default:
      return React__default.createElement(AgentBadgePrimary, _babelHelpers._extends({ initialFirstName: initialFirstName }, props));
  }
};
AgentBadge.propTypes = {
  /** Component ID */
  id: PropTypes$1.string,
  /** Image source */
  imageSrc: PropTypes$1.string,
  /** Agent display name */
  displayName: PropTypes$1.string.isRequired,
  /** Agent information */
  information: PropTypes$1.string,
  /** Is agent verified */
  isVerified: PropTypes$1.bool,
  /** Component's margin */
  margin: PropTypes$1.string,
  /** On click badge function */
  onClick: PropTypes$1.func,
  /* width of imageSrc */
  width: PropTypes$1.string,
  /* height of imageSrc */
  height: PropTypes$1.string,
  /* width of imageSrc */
  mWidth: PropTypes$1.string,
  /* height of imageSrc */
  mHeight: PropTypes$1.string,
  /* font size of title */
  titleSize: PropTypes$1.string,
  /* font size of sub title */
  subTitleSize: PropTypes$1.string,
  /** Agent sub information (address, email) */
  subInformations: PropTypes$1.array,
  /** Badge styles */
  badgeStyle: PropTypes$1.shape({
    /** Badge background color */
    backgroundColor: PropTypes$1.string,
    /** Badge text color */
    textColor: PropTypes$1.string,
    /* width of imageSrc */
    width: PropTypes$1.string,
    /* height of imageSrc */
    height: PropTypes$1.string,
    /* width of imageSrc */
    mWidth: PropTypes$1.string,
    /* height of imageSrc */
    mHeight: PropTypes$1.string
  }),
  /** lineHeight of title */
  titleLineHeight: PropTypes$1.string,
  /** lineHeight of sub title */
  subTitleLineHeight: PropTypes$1.string,
  /** weight of title  */
  titleWeight: PropTypes$1.string,
  /** weight of sub title */
  subTitleWeight: PropTypes$1.string,
  /** color of title */
  titleColor: PropTypes$1.string,
  /** color of hover title */
  titleHoverColor: PropTypes$1.string
};

AgentBadge.defaultProps = {
  id: "agentBadge"
};
AgentBadge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AgentBadge",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"agentBadge\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Component ID"
    },
    "imageSrc": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Image source"
    },
    "displayName": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Agent display name"
    },
    "information": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Agent information"
    },
    "isVerified": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Is agent verified"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Component's margin"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "On click badge function"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "titleSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subTitleSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subInformations": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Agent sub information (address, email)"
    },
    "badgeStyle": {
      "type": {
        "name": "shape",
        "value": {
          "backgroundColor": {
            "name": "string",
            "description": "Badge background color",
            "required": false
          },
          "textColor": {
            "name": "string",
            "description": "Badge text color",
            "required": false
          },
          "width": {
            "name": "string",
            "required": false
          },
          "height": {
            "name": "string",
            "required": false
          },
          "mWidth": {
            "name": "string",
            "required": false
          },
          "mHeight": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Badge styles"
    },
    "titleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "lineHeight of title"
    },
    "subTitleLineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "lineHeight of sub title"
    },
    "titleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "weight of title"
    },
    "subTitleWeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "weight of sub title"
    },
    "titleColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of title"
    },
    "titleHoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of hover title"
    }
  }
};

exports.AgentBadge = AgentBadge;
exports.SimpleTooltip = SimpleTooltip;
//# sourceMappingURL=index-404b8831.js.map
